import { createContext } from "react";


const RefetchAdmin = createContext(1);


export default RefetchAdmin;